import { useState, useEffect } from 'react';
import { NAVY, WHITE, fmt, isOver, PRIORITY_COLORS, STATUS_COLORS, STATUSES } from '../lib/ui';
import { Pill, Select, Empty } from '../lib/ui';

export default function AllTasksView({ tasks, team, setActiveMatter, setActiveTask, filterPreset }) {
  const [filter,         setFilter]         = useState('');
  const [assigneeFilter, setAssigneeFilter] = useState('');
  const [showOverdue,    setShowOverdue]    = useState(false);

  // Apply preset when coming from dashboard KPI click
  useEffect(() => {
    if (!filterPreset) return;
    if (filterPreset.status)  setFilter(filterPreset.status);
    if (filterPreset.overdue) setShowOverdue(true);
  }, [filterPreset]);

  const memberName = id => team.find(t=>t.id===id)?.name||'—';

  const PRIORITY_ORDER = { Critical:0, High:1, Medium:2, Low:3 };

  const filtered = tasks.filter(t =>
    (!filter       || t.status === filter) &&
    (!assigneeFilter || (t.assignees||[]).includes(assigneeFilter)) &&
    (!showOverdue  || (isOver(t.deadline) && t.status!=='Completed' && t.status!=='Closed'))
  ).sort((a,b) => (PRIORITY_ORDER[a.priority]??99) - (PRIORITY_ORDER[b.priority]??99));

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
      <div style={{ display:'flex', gap:10, flexWrap:'wrap', alignItems:'center' }}>
        <Select value={filter} onChange={e=>{ setFilter(e.target.value); setShowOverdue(false); }} style={{ maxWidth:200 }}>
          <option value="">All Statuses</option>
          {STATUSES.map(s=><option key={s}>{s}</option>)}
        </Select>
        <Select value={assigneeFilter} onChange={e=>setAssigneeFilter(e.target.value)} style={{ maxWidth:200 }}>
          <option value="">All Team Members</option>
          {team.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
        </Select>
        {showOverdue && (
          <div style={{ display:'flex', alignItems:'center', gap:6, background:'#FDF0EE', border:'1px solid #F5C0B8', borderRadius:20, padding:'4px 12px', fontSize:12, color:'#C0392B', fontWeight:600 }}>
            Overdue only
            <button onClick={()=>setShowOverdue(false)} style={{ background:'none', border:'none', color:'#C0392B', cursor:'pointer', fontSize:14, padding:'0 0 0 4px', lineHeight:1 }}>×</button>
          </div>
        )}
        {(filter || showOverdue) && (
          <button onClick={()=>{ setFilter(''); setShowOverdue(false); setAssigneeFilter(''); }} style={{ background:'none', border:'1px solid #D0CBBF', borderRadius:6, padding:'5px 10px', fontSize:12, cursor:'pointer', color:'#888', fontFamily:'inherit' }}>Clear filters</button>
        )}
        <div style={{ fontSize:12, color:'#888' }}>{filtered.length} task{filtered.length!==1?'s':''}</div>
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
        {filtered.map(t => (
          <div key={t.id} onClick={()=>{ setActiveMatter(t.matter_id); setTimeout(()=>setActiveTask(t.id), 80); }}
            style={{ background:WHITE, borderRadius:8, border:'1px solid #E5E0D8', padding:'14px 16px', display:'flex', gap:14, alignItems:'center', cursor:'pointer', transition:'box-shadow 0.1s' }}
            onMouseEnter={e=>e.currentTarget.style.boxShadow='0 2px 12px rgba(27,42,74,0.1)'}
            onMouseLeave={e=>e.currentTarget.style.boxShadow='none'}>
            <div style={{ flex:1 }}>
              <div style={{ display:'flex', gap:8, alignItems:'center', marginBottom:4, flexWrap:'wrap' }}>
                <span style={{ fontSize:14, fontWeight:600, color:NAVY }}>{t.title}</span>
                <Pill label={t.priority} color={PRIORITY_COLORS[t.priority]} size={11} />
                {isOver(t.deadline) && t.status!=='Completed' && t.status!=='Closed' && <Pill label="Overdue" color="#C0392B" size={10} />}
              </div>
              <div style={{ fontSize:12, color:'#888' }}>
                {t.matterName} · {(t.assignees||[]).map(memberName).join(', ')} · Due {fmt(t.deadline)}
              </div>
            </div>
            <Pill label={t.status} color={STATUS_COLORS[t.status]} size={11} />
          </div>
        ))}
        {filtered.length===0 && <Empty text="No tasks match your filters." />}
      </div>
    </div>
  );
}
